import React, { Component } from "react";
import Modal from "react-modal";

import config from "../../config";
import { MdClose } from "react-icons/md";
import utilityFunctions from "../../store/utilityFunctions";

Modal.setAppElement("body");

export default class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      redirect: false,
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
      showPassword: false,
      errorText: [],
    };
  }

  handleSubmit = async (event) => {
    this.setState({ loading: true });
    event.preventDefault();
    let pwdErrorCheck = [];
    if (this.state.oldPwd.length < 8 || this.state.newPwd.length < 8 || this.state.confirmPwd.length < 8) {
      pwdErrorCheck.push("Password length must greater that 8 char. ");
    }
    if (this.state.newPwd !== this.state.confirmPwd) {
      pwdErrorCheck.push("New password doesn't match with confirm password.");
    }
    if (pwdErrorCheck.length) {
      this.setState({ errorText: pwdErrorCheck });
      return;
    }

    let payload = {
      old_password: this.state.oldPwd,
      new_password: this.state.newPwd,
      confirm_password: this.state.confirmPwd,
    };

    const userInfo = localStorage?.getItem("userInfo") || utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let url = config.backendServer + "password/staff/change/";

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        if (response.ok) {
          this.props.handleCloseModal();
          alert("New password has been saved");
          return;
        } else {
          const error = await response.json();
          throw error;
        }
      })
      .catch((resp) => {
        this.setState({
          isLoading: false,
        });
        const regex = new RegExp(`[${["{", "}", '"'].join("")}]`, "g");
        const str = JSON.stringify(resp).replace(regex, "");
        this.setState({
          errorText: str,
        });

        //   this.setState({
        //     errorText: JSON.stringify(resp).replace("\n", "").replace("}", "").replace("}", ""),
        //   });
      });
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleShowPasswordChange = (event) => {
    this.setState({ showPassword: event.target.checked });
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className={"card"} style={{ height: "100%" }}>
          <button onClick={() => this.props.handleCloseModal()} className={"confirm-modal-close"}>
            <MdClose />
          </button>

          <h6 className={"card-header"}>Change Password</h6>

          <div className="card-body">
            <div className={" d-flex flex-column gap-2"}>
              <div>
                <label className={"single-warranty-details-label"}>
                  Old Password <sup>*</sup>
                </label>
                <input
                  type={this.state.showPassword ? "text" : "password"}
                  id="oldPwd"
                  className="form-control"
                  required
                  value={this.state.oldPwd}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              <div>
                <label className={"single-warranty-details-label"}>
                  New Password<sup>*</sup>
                </label>
                <input
                  type={this.state.showPassword ? "text" : "password"}
                  id="newPwd"
                  className="form-control"
                  required
                  value={this.state.newPwd}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              <div>
                <label className={"single-warranty-details-label"}>
                  Confirm Password<sup>*</sup>
                </label>
                <input
                  type={this.state.showPassword ? "text" : "password"}
                  id="confirmPwd"
                  className="form-control"
                  required
                  value={this.state.confirmPwd}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              <div className="mt-2">
                <label className="d-flex align-items-center">
                  <input type="checkbox" checked={this.state.showPassword} onChange={this.handleShowPasswordChange} className="me-2" />
                  Show password
                </label>
              </div>

              <span className="text-danger font-weight-light">{this.state.errorText}</span>
            </div>
          </div>
          <div className="card-footer">
            <button className="btn btn-primary btm-sm mr-2" type="submit">
              Submit
            </button>
            <button onClick={() => this.props.handleCloseModal()} className="btn btn-secondary btm-sm">
              Close
            </button>
          </div>
        </div>
      </form>
    );
  }
}
